import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './index.css'

import { browser, htmlDecode } from './mixins'

// Fetch polyfill https://github.com/github/fetch
import 'whatwg-fetch'
// https://www.npmjs.com/package/vue-mq
import VueMq from 'vue-mq'
// https://github.com/hilongjw/vue-progressbar
import VueProgressBar from 'vue-progressbar'
// https://github.com/anteriovieira/vue-youtube
import VueYoutube from 'vue-youtube'
// https://github.com/vue-a11y/vue-announcer
import VueAnnouncer from 'vue-announcer'
// https://github.com/redxtech/vue-plyr

Vue.use(VueMq, {
  breakpoints: {
    sm: 576,
    md: 768,
    lg: 1024,
    xl: 1280,
    xxl: 1600
  }
})

Vue.use(browser)
Vue.use(VueYoutube)
Vue.use(VueAnnouncer)

Vue.use(VueProgressBar, {
  color: 'rgb(84, 56, 140)',
  failedColor: 'red',
  height: '4px'
})

Vue.mixin(htmlDecode)

Vue.config.productionTip = false
Vue.config.devtools = true

export const bus = new Vue()

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
